import { retargetEvent } from "./templateEvent";
import { smsSegments } from "./smsSegments";

export const starterText = (starter, eventId, placeholders) => (eventId
  ? retargetEvent(starter.text, eventId)
  : starter.text.replace(/\{\{event\.(\w+)\}\}/g, (_tag, field) => placeholders[field]));

export const insertAtCursor = (text, tag, start, end) => {
  const before = text.slice(0, start);
  const after = text.slice(end);
  const lead = before && !/\s$/.test(before) ? " " : "";
  const trail = after && !/^[\s.,!?:;]/.test(after) ? " " : "";
  const inserted = `${lead}${tag}${trail}`;

  return { text: `${before}${inserted}${after}`, cursor: before.length + lead.length + tag.length };
};

const count = (value) => Number(String(value).replace(/,/g, "")) || 0;

export const smsChecklist = ({ recipientsCount, audience, template, senderName, delivered, messageErrors = [] }) => {
  const fans = count(recipientsCount);
  const { segments } = smsSegments(template);
  const hasMessage = Boolean((template || "").trim()) && Boolean(senderName);
  const messageOk = hasMessage && messageErrors.length === 0;
  const plural = segments === 1 ? "segment" : "segments";

  return [
    {
      step: "recipients",
      label: "Recipients",
      ok: fans > 0,
      text: fans > 0 ? `${recipientsCount} fans · ${audience}` : "Pick who should get this text",
    },
    {
      step: "message",
      label: "Message",
      ok: messageOk,
      text: messageOk
        ? `${segments} ${plural} · from ${senderName}`
        : hasMessage ? "Fix the errors in your message" : "Write your message",
    },
    { step: "schedule", label: "Delivery", ok: delivered.ok, text: delivered.text },
    {
      step: "message",
      label: "Billed messages",
      ok: true,
      info: true,
      text: `${(fans * segments).toLocaleString("en-US")} texts (${segments} ${plural} each) for ${recipientsCount} fans`,
    },
  ];
};

export const moreMergeFields = ({ fanTags = [], eventTags = [], shownValues = [], eventId = null }) => ({
  fan: fanTags.filter((tag) => !shownValues.includes(tag.value)),
  event: eventId
    ? eventTags
      .filter((tag) => !tag.value.endsWith("_obj}}") && !shownValues.includes(tag.value))
      .map((tag) => ({ name: tag.name, value: retargetEvent(tag.value, eventId) }))
    : [],
});

export const formatSenderNumber = (number) => {
  const digits = number.replace(/\D/g, "");
  const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;

  if (national.length !== 10) return number;
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
};

export const senderLabel = (service) => {
  const numbers = (service?.twilio_phone_numbers || []).map((entry) => entry.phone_number).filter(Boolean);

  if (numbers.length === 0) return service?.name || "";
  const first = formatSenderNumber(numbers[0]);
  return numbers.length > 1 ? `${first} +${numbers.length - 1} more` : first;
};
